<script lang="ts">
  import type { Session } from '../lib/session.svelte';
  let { session }: { session: Session } = $props();
  const label = $derived(
    {
      idle: 'IDLE',
      connecting: 'CONNECTING',
      connected: 'LIVE',
      reconnecting: `RECONNECTING${session.attempt > 1 ? ` (${session.attempt})` : ''}`,
      error: 'ERROR',
      kicked: 'DISCONNECTED',
    }[session.status],
  );
  const cls = $derived(session.status === 'connected' ? 'ok' : session.status === 'reconnecting' || session.status === 'connecting' ? 'warn' : 'bad');
</script>

<span class="badge {cls}" title={session.error ?? ''}>
  {label}{#if session.status === 'connected' && session.stats.rttMs !== null}&nbsp;· {Math.round(session.stats.rttMs)} ms{/if}
</span>
